/**
 * iter339 — Horaire du garage : petit bouton engrenage dans Pointage — Administration,
 * réservé à l'admin. Ouvre la configuration de l'horaire avec date d'entrée en vigueur.
 */
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Settings } from "lucide-react";
import PointageHoraireCard from "@/components/parametres/PointageHoraireCard";

export default function PointageHoraireBtn() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" size="icon" onClick={() => setOpen(true)}
              title="Régler l'horaire du garage" data-testid="pointage-horaire-btn">
        <Settings className="w-4 h-4" />
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl max-h-[88vh] overflow-y-auto" data-testid="pointage-horaire-dialog">
          <DialogHeader>
            <DialogTitle>Horaire du garage</DialogTitle>
            <DialogDescription>
              Sert de référence au calcul des retards et des heures dues.
            </DialogDescription>
          </DialogHeader>
          <PointageHoraireCard />
        </DialogContent>
      </Dialog>
    </>
  );
}
